import axios from 'axios';
import properties from '../properties';
import EmployerGroupStore from '../../stores/EmployerGroupStore';

export interface SpecificDeductibleAnalysisData {
  category: string;
  membersCount: number;
  totalCost: string;
  changePercent: number;
  members: string[];
  pmpm: string;
}

export const getSpecificDeductibleAmount = async (
  startDate: any,
  endDate: any,
  eg_nid: any,
  employerGroupStore: EmployerGroupStore,
) => {
  try {
    const baseUrl = properties.aiqBaseUrl + properties.specificDeductible;
    const requestBody = {
      startDate,
      endDate,
      eg_nid,
    };

    const res = await axios.post(baseUrl, requestBody);
    if (res && res.data && res.data.data) {
      const deductibleAmount = res?.data?.data?.specific_deductible ?? 25000;
      employerGroupStore.setDeductibleAmount(deductibleAmount);
      await getSpecificDeductibleAnalsysis(
        startDate,
        endDate,
        eg_nid,
        employerGroupStore,
        deductibleAmount?.toString(),
      );
    }
  } catch (error) {
    console.error('Error in fetching deductible amount:', error);
    // Handle error if needed
  }
};

const getSpecificDeductibleAnalsysis = async (
  startDate: any,
  endDate: any,
  eg_nid: any,
  employerGroupStore: EmployerGroupStore,
  value: string,
) => {
  const baseUrl = properties.aiqBaseUrl + properties.getReportPlan;
  const requestBody = {
    startDate,
    endDate,
    eg_nid: eg_nid,
    deductible_amount: value,
  };
  await axios
    .post(baseUrl, requestBody)
    .then((res) => {
      if (res) {
        // Find the "50%" category and update the membersFor50Percent state
        const category50Data = res?.data?.data?.categories?.find(
          (item: any) => item.category === '50%',
        );
        if (category50Data) {
          employerGroupStore.setMemberIdsCrossing50PercentDeductible(
            category50Data?.members,
          );
        }
      }
    })
    .catch(() => {});
};
